"use client";

import { forwardRef, memo } from "react";

const cn = (...cls) => cls.filter(Boolean).join(" ");

const Card = memo(
  forwardRef(function Card(
    { as: Tag = "div", children, className = "", hover = false, interactive = false, ...props },
    ref
  ) {
    const base =
      "bg-white rounded-2xl border border-gray-100 shadow-sm p-6";
    const hoverCls = hover
      ? "transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg will-change-transform"
      : "";
    const interactiveCls = interactive
      ? "focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:ring-offset-2"
      : "";

    return (
      <Tag ref={ref} className={cn(base, hoverCls, interactiveCls, className)} {...props}>
        {children}
      </Tag>
    );
  })
);

export default Card;
